import classes from "./CartIngredientBar.module.css";

// component representing each ingredient in cart
const CartIngredientBar = (props) => {
  return (
    <div className={classes.cart_ingredient_card}>
      <div className={classes.image_blocker}>
        <img className={classes.ingredient_image} src={props.image} alt="new" />
      </div>
      <div className={classes.title}>{props.title}</div>
      <div className={classes.volume}>
        {props.volume}
        {props.unit}
      </div>
    </div>
  );
};

export default CartIngredientBar;
